
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bootcamp",
      function () {
        return require("private-next-pages/bootcamp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bootcamp"])
      });
    }
  